/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Access_ProhibitedInputs */

const en_vault_access_prohibited = /** @type {(inputs: Vault_Access_ProhibitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have full ownership of these premium assets. Direct link sharing is prohibited.`)
};

const id_vault_access_prohibited = /** @type {(inputs: Vault_Access_ProhibitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda memiliki kepemilikan penuh atas aset premium ini. Berbagi tautan langsung dilarang.`)
};

/** @type {(inputs: Vault_Access_ProhibitedInputs) => LocalizedString} */
const es_vault_access_prohibited = en_vault_access_prohibited;

/** @type {(inputs: Vault_Access_ProhibitedInputs) => LocalizedString} */
const fr_vault_access_prohibited = en_vault_access_prohibited;

/** @type {(inputs: Vault_Access_ProhibitedInputs) => LocalizedString} */
const de_vault_access_prohibited = en_vault_access_prohibited;

/** @type {(inputs: Vault_Access_ProhibitedInputs) => LocalizedString} */
const ja_vault_access_prohibited = en_vault_access_prohibited;

/** @type {(inputs: Vault_Access_ProhibitedInputs) => LocalizedString} */
const zh_vault_access_prohibited = en_vault_access_prohibited;

/** @type {(inputs: Vault_Access_ProhibitedInputs) => LocalizedString} */
const ar_vault_access_prohibited = en_vault_access_prohibited;

/** @type {(inputs: Vault_Access_ProhibitedInputs) => LocalizedString} */
const it_vault_access_prohibited = en_vault_access_prohibited;

/** @type {(inputs: Vault_Access_ProhibitedInputs) => LocalizedString} */
const ru_vault_access_prohibited = en_vault_access_prohibited;

/** @type {(inputs: Vault_Access_ProhibitedInputs) => LocalizedString} */
const pt_vault_access_prohibited = en_vault_access_prohibited;

/** @type {(inputs: Vault_Access_ProhibitedInputs) => LocalizedString} */
const ko_vault_access_prohibited = en_vault_access_prohibited;

/**
* | output |
* | --- |
* | "You have full ownership of these premium assets. Direct link sharing is prohibited." |
*
* @param {Vault_Access_ProhibitedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_access_prohibited = /** @type {((inputs?: Vault_Access_ProhibitedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Access_ProhibitedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_access_prohibited(inputs)
	if (locale === "es") return es_vault_access_prohibited(inputs)
	if (locale === "fr") return fr_vault_access_prohibited(inputs)
	if (locale === "de") return de_vault_access_prohibited(inputs)
	if (locale === "ja") return ja_vault_access_prohibited(inputs)
	if (locale === "zh") return zh_vault_access_prohibited(inputs)
	if (locale === "ar") return ar_vault_access_prohibited(inputs)
	if (locale === "id") return id_vault_access_prohibited(inputs)
	if (locale === "it") return it_vault_access_prohibited(inputs)
	if (locale === "ru") return ru_vault_access_prohibited(inputs)
	if (locale === "pt") return pt_vault_access_prohibited(inputs)
	return ko_vault_access_prohibited(inputs)
});